<template>
	<div class="menu__has-bbox-tooltip display-inline-block menu" @click.stop="changeShowMenu">
		<slot name="customIcon"> </slot>
		<transition v-if="!$slots.customIcon" name="fade">
			<bbox-icon class="icon" v-show="mobile ? mobile : visible">
				<icon-more-vertical class="font-size-huge ink-lighter-1"></icon-more-vertical>
			</bbox-icon>
		</transition>
		<transition name="fade" @enter="enterTransition">
			<div
				class="menu__bbox-tooltip display-flex justify-content-center align-content-center margin-top-tiny"
				v-click-outside="closeMenu"
				:class="[position]"
				v-show="showMenu && visible"
			>
				<Card
					:elevation="4"
					class="border border-white-darker-4 padding-top-tiny padding-bottom-tiny"
				>
					<ul class="margin-0 padding-0">
						<li
							v-for="(option, index) in options"
							:key="index"
							style="list-style-type:none;"
							class="padding-top-tiny padding-bottom-tiny bg-hover-white-darker-3"
							:class="{ 'border-bottom border-white-darker-4 list-items cursor-pointer': isList }"
						>
							<p
								class="margin-0 display-flex font-size-big semi-bold padding-left-normal padding-right-normal white-space-nowrap"
								:class="option.color ? option.color : 'ink-lighter-1'"
								@click.stop.prevent="option.method(option.params)"
							>
								<bbox-icon v-if="option.icon" class="margin-right-tiny"
									><component :is="option.icon" style="height: 100%;"></component></bbox-icon
								>{{ option.text }}
							</p>
						</li>
					</ul>
				</Card>
			</div>
		</transition>
	</div>
</template>

<script>
import BboxIcon from './Icon.vue';
import Card from './Card.vue';
import IconMoreVertical from './icons/IconMoreVertical.vue';

export default {
	props: {
		visible: {
			type: Boolean,
			default: true
		},
		/* Formato do Array options
        [
            {icon:'icon-create', text:'Editar', color: 'ink-lighter-1', method:edit, params: product},
            {text:'Desativar', color: 'red-base', method:edit, params: product}
        ]
        */
		options: Array,
		position: {
			type: String,
			default: 'bottom'
		},
		type: {
			type: String,
			default: 'menu'
		}
	},
	data() {
		return {
			showMenu: false
		};
	},
	components: {
		BboxIcon,
		Card,
		'icon-more-vertical': IconMoreVertical
	},
	watch: {
		visible() {
			if (!this.visible) this.showMenu = false;
		}
	},
	directives: {
		'click-outside': {
			bind: function(el, binding, vnode) {
				el.clickOutsideEvent = function(event) {
					// here I check that click was outside the el and his childrens
					if (!(el == event.target || el.contains(event.target))) {
						// and if it did, call method provided in attribute value
						vnode.context[binding.expression](event);
					}
				};
				document.body.addEventListener('click', el.clickOutsideEvent);
			},
			unbind: function(el) {
				document.body.removeEventListener('click', el.clickOutsideEvent);
			}
		}
	},
	computed: {
		mobile() {
			return window.innerWidth < 1024 ? true : false;
		},
		isList() {
			return this.type == 'list' ? true : false;
		}
	},
	methods: {
		changeShowMenu() {
			this.showMenu = !this.showMenu;
		},
		closeMenu() {
			this.showMenu = false;
		},
		changePosition: function(position) {
			this.position = position;
		},
		enterTransition: function(el) {
			var windowOffsetRight =
				window.innerWidth - el.closest('.menu__has-bbox-tooltip').getBoundingClientRect().right;
			var windowOffsetLeft = el.closest('.menu__has-bbox-tooltip').getBoundingClientRect().left;
			var windowOffsetBottom =
				window.innerHeight - el.closest('.menu__has-bbox-tooltip').getBoundingClientRect().top;
			var menuWidth = el.children[0].offsetWidth;
			if (windowOffsetLeft < menuWidth) {
				if (windowOffsetBottom >= menuWidth) {
					this.changePosition('bottom');
					el.classList.remove('top', 'left', 'right');
					el.classList.add('bottom');
					return;
				} else {
					this.changePosition('right');
					el.classList.remove('bottom', 'top', 'left');
					el.classList.add('top');
					return;
				}
			} else if (windowOffsetRight < menuWidth) {
				if (windowOffsetBottom >= menuWidth) {
					this.changePosition('left');
					el.classList.remove('top', 'bottom', 'right');
					el.classList.add('left');
					return;
				} else {
					this.changePosition('top');
					el.classList.remove('bottom', 'left', 'right');
					el.classList.add('top');
					return;
				}
			}
		}
	}
};
</script>

<style scoped lang="scss">
.list-items {
	&:last-child {
		border-bottom: none;
	}
}
</style>

<style>
.menu__has-bbox-tooltip {
	position: relative;
}
.menu__bbox-tooltip {
	position: absolute;
	z-index: 3;
	width: fit-content;
	justify-items: center;
	align-items: center;
}
.menu__bbox-tooltip.top {
	transform: translate(calc(-100% + 2.625rem), calc(-100% - 2.625rem - 0.8rem));
	margin: 0;
}
.menu__bbox-tooltip.right {
	transform: translate(0%, calc(-100% - 2.625rem - 0.8rem));
	margin: 0;
}
.menu__bbox-tooltip.bottom {
	margin-top: 0.8rem;
}
.menu__bbox-tooltip.left {
	transform: translate(calc(-100% + 2.625rem), 0);
	margin-top: 0.8rem;
}
.menu__bbox-tooltip-banner {
	max-width: 27rem;
	box-shadow: 0px 4px 5px 0 rgba(0, 0, 0, 0.14);
}

.fade-enter {
	opacity: 0;
}
.fade-enter-active {
	transition: opacity 0.1s;
}
.fade-leave {
	/* opacity: 1; */
}
.fade-leave-active {
	transition: opacity 0.1s;
	opacity: 0;
}
</style>

<docs>

#### HoveringMenu
Este componente é utilizado para exibir um menu de contexto flutuante.

```js

<hovering-menu :visible="true" :options="[
    {icon: 'icon-edit', text: 'Editar', method: editMethod, params: param},
    { color: 'red-base', text: 'Deletar', method: deleteMethod, params: param}
]"></hovering-menu>

```

</docs>
